import { render, staticRenderFns } from "./PageBuilderActionWidget.vue?vue&type=template&id=3134dbfa"
import script from "./PageBuilderActionWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderActionWidget.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderActionWidget.vue?vue&type=style&index=0&id=3134dbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports